const PointerArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.18231 12.668C3.94799 12.9023 3.56766 12.9023 3.33335 12.668C3.09922 12.4337 3.09928 12.054 3.33335 11.8197L4.18231 12.668ZM12.8431 8.47266C12.843 8.80398 12.5742 9.07228 12.2429 9.07227C11.9115 9.07225 11.6427 8.80395 11.6426 8.47266V5.20703L4.18231 12.668L3.33335 11.8197L10.7943 4.35872H7.52931C7.19794 4.35872 6.92905 4.08983 6.92905 3.75846C6.92905 3.42709 7.19794 3.1582 7.52931 3.1582H12.2429C12.4019 3.1582 12.5548 3.22153 12.6673 3.33398C12.7799 3.44651 12.8431 3.59934 12.8431 3.75846V8.47266Z"
        fill="#585858"
      />
    </svg>
  );
};

export default PointerArrow;
